// Dictionary lookup shared by the React context (t) and non-component code (tr).
// Keys are the English source text; a missing key falls back to the English text, so English rendering never changes.
// Placeholders: t('Showing {count} assets', { count }) — values are inserted verbatim (numbers, codes and user data are never translated).
import ar from './locales/ar/index.js';
import tl from './locales/tl/index.js';
import hi from './locales/hi/index.js';
import ml from './locales/ml/index.js';
import { getActiveLanguage } from './format.js';

export const DICTIONARIES = { ar, tl, hi, ml };

const fill = (text, vars) =>
  vars ? String(text).replace(/\{(\w+)\}/g, (m, k) => (Object.prototype.hasOwnProperty.call(vars, k) && vars[k] != null ? String(vars[k]) : m)) : text;

export function translate(language, text, vars) {
  if (text == null || text === '') return text;
  const dict = DICTIONARIES[language];
  return fill((dict && dict[text]) || text, vars);
}

/** Translate outside React (handlers, helpers, error messages) using the currently active language. */
export const tr = (text, vars) => translate(getActiveLanguage(), text, vars);

/** Marks a static English string for extraction (scripts/i18n-check.mjs) without translating it; translate it later with t(). */
export const tk = (text) => text;
